import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage/plugin-tech-radar';
import { IdentityApi } from '@backstage/core-plugin-api';

export class CustomTechRadarApi implements TechRadarApi {
  private readonly customIdentityApi: IdentityApi;
  private readonly baseUrl: string;

  constructor(identityApi: IdentityApi, baseUrl: string) {
    this.customIdentityApi = identityApi;
    this.baseUrl = baseUrl;
  }

  async getBaseUrl() {
    return `${this.baseUrl}/api/tech-radar`;
  }

  async load(): Promise<TechRadarLoaderResponse> {
    const baseUrl = await this.getBaseUrl();
    const { token } = await this.customIdentityApi.getCredentials();
    const response = await fetch(`${baseUrl}`, {
      headers: token
        ? {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });
    if (!response.ok) {
      throw new Error(
        `failed to fetch data, status ${response.status}: ${response.statusText}`,
      );
    }
    return await response.json();
  }
}
